import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext/AuthContext";

const Header = ({ onLogout }) => {
  const { user } = useContext(AuthContext);

  return (
    <header className="">
      <div className="topbar">
        <div className="container-fluid">
          <div className="navbar-header">
            <div className="d-flex align-items-center gap-2">
              <div className="logo-box">
                <a href="" className="logo-dark">
                  <img src="/assets/images/logo.png" className="logo-lg" alt="logo dark" />
                </a>
              </div>
            </div>

            <div className="d-flex align-items-center gap-1">
              {/* <div className="topbar-item d-none d-md-flex">
                <button type="button" className="topbar-button" id="theme-settings-btn" data-bs-toggle="offcanvas" data-bs-target="#theme-settings-offcanvas" aria-controls="theme-settings-offcanvas">
                  <i className="ri-settings-4-line fs-24"></i>
                </button>
              </div> */}
              {/* <!-- User --> */}
              <div className="dropdown topbar-item">
                <a type="button" className="topbar-button" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span className="d-flex align-items-center">
                    {user ? (
                      <>
                        <i>{user.name}</i>
                        <div className="user-photo">
                          {user.role === 1 ? (
                            <img className="rounded-circle avatar-sm" width="32" src="/assets/images/alica-pare.jpg" alt="avatar-3" />
                          ) : (
                            <p className="user-name-short">
                              {user.first_name?.charAt(0).toUpperCase()}
                              {user.last_name?.charAt(0).toUpperCase()}
                            </p>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <i>Loading...</i>
                        <div className="user-photo"></div>
                      </>
                    )}
                  </span>
                </a>
                <div className="dropdown-menu dropdown-menu-end">
                  {/* <!-- item--> */}
                  <h6 className="dropdown-header">Welcome Alice Pare</h6>

                  <a className="dropdown-item" href="pages-calendar.html">
                    <iconify-icon icon="solar:calendar-broken" className="align-middle me-2 fs-18"></iconify-icon>
                    <span className="align-middle">My Schedules</span>
                  </a>
                  <a className="dropdown-item" href="auth-password.html">
                    <iconify-icon icon="hugeicons:reset-password" className="align-middle me-2 fs-18"></iconify-icon>
                    <span className="align-middle">Reset Password</span>
                  </a>
                  <div className="dropdown-divider my-1"></div>
                  <button type="button" className="dropdown-item text-danger" onClick={onLogout}>
                    <iconify-icon icon="solar:logout-3-broken" className="align-middle me-2 fs-18"></iconify-icon>
                    <span className="align-middle">Logout</span>
                  </button>
                </div>
              </div>
              <div className="dropdown topbar-item">
                <button type="button" className="topbar-button position-relative" id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i className="ri-notification-3-line fs-24"></i>
                  <span className="position-absolute topbar-badge fs-10 translate-middle badge bg-danger rounded-pill">
                    3<span className="visually-hidden">unread messages</span>
                  </span>
                </button>
                <div className="dropdown-menu py-0 dropdown-lg dropdown-menu-end" aria-labelledby="page-header-notifications-dropdown">
                  <div className="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                    <div className="row align-items-center">
                      <div className="col">
                        <h6 className="m-0 fs-16 fw-semibold"> Notifications</h6>
                      </div>
                      <div className="col-auto">
                        <a href="javascript: void(0);" className="text-dark text-decoration-underline">
                          <small>Clear All</small>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div data-simplebar style={{ maxHeight: "280px" }}>
                    {/* <!-- Item --> */}
                    <a href="javascript:void(0);" className="dropdown-item py-3 border-bottom text-wrap">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <div className="avatar-sm me-2">
                            <span className="avatar-title bg-soft-info text-info fs-20 rounded-circle">J</span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="mb-0">
                            <span className="fw-medium">Josephine Thompson </span>
                            commented on admin
                          </p>
                        </div>
                      </div>
                    </a>
                    {/* <!-- Item --> */}
                    <a href="javascript:void(0);" className="dropdown-item py-3 border-bottom">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <div className="avatar-sm me-2">
                            <span className="avatar-title bg-soft-info text-info fs-20 rounded-circle">D</span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="mb-0 fw-semibold">Donoghue Susan</p>
                          <p className="mb-0 text-wrap">Hi, How are you? What about our next meeting</p>
                        </div>
                      </div>
                    </a>
                    {/* <!-- Item --> */}
                    <a href="javascript:void(0);" className="dropdown-item py-3 border-bottom">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <div className="avatar-sm me-2">
                            <span className="avatar-title bg-soft-warning text-warning fs-20 rounded-circle">
                              <iconify-icon icon="solar:leaf-broken"></iconify-icon>
                            </span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="mb-0 fw-semibold">Jacob Gines</p>
                          <p className="mb-0 text-wrap">Answered to your comment on the cash flow forecast's graph 🔔.</p>
                        </div>
                      </div>
                    </a>
                    {/* <!-- Item --> */}
                    <a href="javascript:void(0);" className="dropdown-item py-3 border-bottom">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <div className="avatar-sm me-2">
                            <span className="avatar-title bg-soft-warning text-warning fs-20 rounded-circle">
                              <iconify-icon icon="solar:leaf-broken"></iconify-icon>
                            </span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="mb-0 fw-semibold text-wrap">
                            You have received <b>20</b> new messages in the conversation
                          </p>
                        </div>
                      </div>
                    </a>
                    {/* <!-- Item --> */}
                    <a href="javascript:void(0);" className="dropdown-item py-3 border-bottom">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <div className="avatar-sm me-2">
                            <span className="avatar-title bg-soft-warning text-warning fs-20 rounded-circle">
                              <iconify-icon icon="solar:leaf-broken"></iconify-icon>
                            </span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <p className="mb-0 fw-semibold">Shawn Bunch</p>
                          <p className="mb-0 text-wrap">Commented on Admin</p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="text-center py-3">
                    <a href="javascript:void(0);" className="btn btn-primary btn-blue">
                      View All Notification <i className="ri-arrow-right-line ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <a href="https://alicepare.api.ayatasgroup.com/clio/redirect" target="_blank" rel="noreferrer" className="nav-link">
                  <span className="nav-icon">
                    <i className="ri-refresh-fill fs-24"></i>
                  </span>
                  {/* <span className="nav-text">Clio Data Update</span> */}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="offcanvas offcanvas-end border-0 rounded-start-4 overflow-hidden" id="theme-settings-offcanvas">
          <div className="d-flex align-items-center bg-primary p-3 offcanvas-header">
            <h5 className="text-white m-0">Theme Settings</h5>
            <button type="button" className="btn-close btn-close-white ms-auto" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>

          <div className="offcanvas-body p-0"></div>
          <div className="offcanvas-footer border-top p-3 text-center">
            <div className="row">
              <div className="col">
                <button type="button" className="btn btn-danger w-100" id="reset-layout">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
